import React from 'react';
interface SuitDividerProps {
  className?: string;
}
export function SuitDivider({
  className = ''
}: SuitDividerProps) {
  return <div className={`flex items-center justify-center gap-3 py-4 ${className}`} aria-hidden="true" data-id="element-194">
      <div className="flex-1 h-px bg-gradient-to-r from-transparent via-goldenrod/50 to-goldenrod/70" data-id="element-195" />
      <span className="text-goldenrod/70 text-sm tracking-[0.5em] font-body select-none" data-id="element-196">
        ♠ ♣ ♥ ♦
      </span>
      <div className="flex-1 h-px bg-gradient-to-l from-transparent via-goldenrod/50 to-goldenrod/70" data-id="element-197" />
    </div>;
}